/*
 * StatsScreen
 * ==========
 */

import ScreenBase from '../ui/ScreenBase'

export default class StatsScreen extends ScreenBase {

    constructor(game, placeholder) {
        super(game, placeholder);
        window.gameOver = this;

        this.offsetY = 2;

        this.params = {
            'lastLevelScore': [-140, -30],
            'lastLevelScoreVal': [140, -30],
            'highestLevel': [-140, 0],
            'highestLevelVal': [140, 0],
            'bestWord': [-140, 30],
            'bestWordVal': [140, 30],
            'bestWordScore': [-140, 60],
            'bestWordScoreVal': [140, 60],
            'linesCleared': [-140, 90],
            'linesClearedVal': [140, 90]
        };

        this.statsOffsetY = 2 * PARAMS.scaleFactor
    }

    initSummaryStats() {
        this.lastLevelScore = this.addText2('lastLevelScore', 'white', 'This Level\'s Score', 20, 0);
        this.lastLevelScoreVal = this.addText2('lastLevelScoreVal', 'white', '10', 20, 1);

        this.highestLevel = this.addText2('highestLevel', 'white', 'Highest Level', 20, 0);
        this.highestLevelVal = this.addText2('highestLevelVal', 'white', '10', 20, 1);
        this.bestWord = this.addText2('bestWord', 'white', 'Best Word', 20, 0);
        this.bestWordVal = this.addText2('bestWordVal', 'white', 'IHAHA', 20, 1);
        this.bestWordScore = this.addText2('bestWordScore', 'white', 'Best Word\'s Score', 20, 0);
        this.bestWordScoreVal = this.addText2('bestWordScoreVal', 'white', '180', 20, 1);
        this.linesCleared = this.addText2('linesCleared', 'white', 'Lines Cleared', 20, 0);
        this.linesClearedVal = this.addText2('linesClearedVal', 'white', '10', 20, 1);

        // return;
        this.lastLevelScore.y += this.statsOffsetY;
        this.lastLevelScoreVal.y += this.statsOffsetY;

        this.highestLevel.y += this.statsOffsetY;
        this.highestLevelVal.y += this.statsOffsetY;

        this.bestWord.y += this.statsOffsetY;
        this.bestWordVal.y += this.statsOffsetY;

        this.bestWordScore.y += this.statsOffsetY;
        this.bestWordScoreVal.y += this.statsOffsetY;

        this.linesCleared.y += this.statsOffsetY;
        this.linesClearedVal.y += this.statsOffsetY
    }

}
